import type { ActionMessage } from '../types';
import { invokeAction } from './invoke';

export interface OpenCameraProps {
  readonly frontFacing?: boolean;
}

export interface OpenCameraResponse {
  readonly image: string;
}

export type OpenCameraAction = ActionMessage<'openCamera', OpenCameraProps, OpenCameraResponse>;
export const openCamera = invokeAction('appAction', 'openCamera');
